
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import Gradient from '@/assets/medihub_gradient_mesh.jpg';

const backgroundImages = [
  Gradient,
];

const HeroSection = () => {
  const selectedBackground = backgroundImages[0]; // Default to first image, can be randomized later

  return (
    <section className="pt-32 pb-20 px-4 relative overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src={selectedBackground}
          alt="MediHub háttér"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/30 z-0"></div>
      </div>

      <div className="container mx-auto relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="lg:w-3/4 text-center lg:text-left"
          >
            <div className="inline-block px-3 py-1 bg-white/20 text-white text-sm font-medium rounded-full mb-4 backdrop-blur-sm">
              Egészségügyi szakembereknek
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight hero-heading">
              Fedezze fel az egészségügyi rendezvényeket <span className="text-medihub-accent">egy helyen</span>
            </h1>

            <p className="text-lg text-white/90 mb-8 max-w-xl mx-auto lg:mx-0">
              A MediHub összegyűjti a magyarországi szakmai rendezvényeket, hogy könnyedén rátaláljon az Ön számára legfontosabb eseményekre
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-8">
              <Link
                to="/why-medihub"
                className="px-6 py-3 bg-medihub-accent text-white rounded-full font-medium hover:bg-medihub-accent/90 transition-colors shadow-lg hover:shadow-xl hover:shadow-medihub-accent/20 flex items-center justify-center sm:justify-start"
              >
                Miért érdemes használnom, mint egészségügyi szakember?
              </Link>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start text-sm text-white">
              <div className="flex items-center">
                <CheckCircle className="w-4 h-4 text-medihub-accent mr-2" />
                Személyre szabott értesítések
              </div>
              <div className="flex items-center">
                <CheckCircle className="w-4 h-4 text-medihub-accent mr-2" />
                Kreditpontos események
              </div>
              <div className="flex items-center">
                <CheckCircle className="w-4 h-4 text-medihub-accent mr-2" />
                Ingyenes regisztráció
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
